import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import ContactUs from './pages/ContactUs/ContactUs';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import Dashboard from './pages/Dashboard/Dashboard';
import Treatment from './pages/Treatments/Treatment';
import CreateTreatment from './pages/Treatments/CreateTreatment';
import AboutUs from './pages/AboutUs/AboutUs';
import Appointments from './pages/Appointments/Appointments';
import InternalUsers from './pages/InternalUsers/InternalUser';
import ExternalUsers from './pages/ExternalUsers/ExternalUser';
import Patients from './pages/Patients/Patients';
import CreatePatient from './pages/Patients/CreatePatient';
import AppointmentsTable from './pages/Appointments/AppointmentsTableView';
import AppointmentDetails from './pages/Appointments/AppointmentDetails';
import AppointmentDetailsUser from './pages/Appointments/AppointmentDetailsUser';
import MyProfile from './pages/MyProfile/MyProfile';
import PatientProfile from './pages/Patients/PatientProfile';
import Reports from './pages/Reports/Reports';
import Inventory from './pages/Inventory/Inventory';
import Dentists from './pages/Dentists/Dentists';
import DentistProfile from './pages/Dentists/DentistProfile'
import Settings from './pages/Settings/Settings';
import FeedbackPage from './pages/FeedbackPage/FeedbackPage';
import EmailVerification from './pages/EmailVerification/EmailVerification';
import Restorative from './pages/Restorative/Restorative';
import Extraction from './pages/Extraction/Extraction';
import CrownBridge from './pages/CrownBridge/CrownBridge';
import Orthodontics from './pages/Orthodontics/Orthodontics';
import SurgicalPro from './pages/SurgicalPro/SurgicalPro';
import Pediatrics from './pages/Pediatrics/Pediatrics';
import Implants from './pages/Implants/Implants';
import Whitening from './pages/Whitening/Whitening';
import Veneers from './pages/Veneers/Veneers';
import Endodontics from './pages/Endodontics/Endodontics';
import PartialDenture from './pages/PartialDenture/PartialDenture';
import CompleteDenture from './pages/CompleteDenture/CompleteDenture';
import Fluoride from './pages/Fluoride/Fluoride';
import OralProphylaxis from './pages/OralProphylaxis/OralProphylaxis';
// import ChatBot from './pages/ChatBot/ChatBot';
import AllServices from './pages/AllServices/AllServices';
import CreateInventory from './pages/Inventory/CreateInventory';
import CreateDentist from './pages/Dentists/CreateDentist';
import ChatApp from './pages/Messages/ChatApp'
import TreatmentDetails from './pages/Treatments/TreatmentDetails';
import CreateAppointmentForm from './pages/Appointments/CreateAppointmentForm';
import InventoryDetails from './pages/Inventory/InventoryDetails';
import StoresDetails from './pages/Inventory/StoresDetails';
import Stores from './pages/Inventory/Stores';
import CreateStores from './pages/Inventory/CreateStores';
import EmailVerificationPage from "./pages/EmailVerification";
import CreateCategory from './pages/Inventory/CreateInventoryCategories';
import Category from './pages/Inventory/Category';
import CreateAppointmentUser from './pages/Appointments/CreateAppointmentUser';
import AppointmentsUser from './pages/Appointments/AppointmentsUser';
import AppointmentsUserCalendar from './pages/Appointments/AppointmentsUserCalendar';
import MyPatientProfile from './pages/Patients/MyPatientProfile';
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import VerifyOTP from "./pages/VerifyOTP/VerifyOTP";
import VerifyOTPEmail from "./pages/ChangeEmail/VerifyOTPEmail";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ChangePassword from './pages/ChangePassword/ChangePassword';
import ResetEmail from './pages/ChangeEmail/ResetEmail';
import ChangeEmail from './pages/ChangeEmail/ChangeEmail';

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/treatment" element={<Treatment />} />
                <Route path="/create-treatment" element={<CreateTreatment />} />
                <Route path="/appointments" element={<Appointments />} />
                <Route path="/internal-users" element={<InternalUsers />} />
                <Route path="/patients" element={<Patients />} />
                <Route path="/create-patient" element={<CreatePatient />} />
                <Route path="/external-users" element={<ExternalUsers />} />
                <Route path="/patient-profile/:id" element={<PatientProfile />} /> {/* Edit Patient route */}
                <Route path="/my-patient-profile/:id" element={<MyPatientProfile />} />
                <Route path="/dentist-profile/:id" element={<DentistProfile />} />
                <Route path="/appointments-table" element={<AppointmentsTable />} /> {/* Edit Patient route */}
                <Route path="/appointment-details/:id" element={<AppointmentDetails />} />
                <Route path="/appointment-details-user/:id" element={<AppointmentDetailsUser />} />
                <Route path="/my-profile" element={<MyProfile />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/suppliers" element={<Stores />} />
                <Route path="/create-suppliers" element={<CreateStores />} />
                <Route path="/dentists" element={<Dentists />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                {/* <Route path="/chat-bot" element={<ChatBot />} /> */}
                <Route path="/email-verification" element={<EmailVerification />} />
                <Route path="/restorative" element={<Restorative />} />
                <Route path="/extraction" element={<Extraction />} />
                <Route path="/crownbridge" element={<CrownBridge />} />
                <Route path="/orthodontics" element={<Orthodontics />} />
                <Route path="/surgicalpro" element={<SurgicalPro />} />
                <Route path="/pediatrics" element={<Pediatrics />} />
                <Route path="/implants" element={<Implants />} />
                <Route path="/whitening" element={<Whitening />} />
                <Route path="/veneers" element={<Veneers />} />
                <Route path="/endodontics" element={<Endodontics />} />
                <Route path="/partialdenture" element={<PartialDenture />} />
                <Route path="/completedenture" element={<CompleteDenture />} />
                <Route path="/fluoride" element={<Fluoride />} />
                <Route path="/oralProphylaxis" element={<OralProphylaxis />} />
                <Route path="/allServices" element={<AllServices />} />
                <Route path="/create-inventory" element={<CreateInventory />} />
                <Route path="/create-dentist" element={<CreateDentist />} />
                <Route path="/chat" element={<ChatApp />} />
                <Route path="/treatment-details/:id" element={<TreatmentDetails />} />
                <Route path="/create-appointment" element={<CreateAppointmentForm />} />
                <Route path="/inventory-details/:id" element={<InventoryDetails />} />
                <Route path="/supplier-details/:id" element={<StoresDetails />} />
                <Route path="/verify-email" element={<EmailVerificationPage />} />
                <Route path="/create-category" element={<CreateCategory />} />
                <Route path="/inventory-categories" element={<Category />} />
                <Route path="/create-appointment-user" element={<CreateAppointmentUser />} />
                <Route path="/appointments-user" element={<AppointmentsUser />} />
                <Route path="/appointments-users-calendar" element={<AppointmentsUserCalendar />} />
                <Route path="/verify-otp" element={<VerifyOTP />} />
                <Route path="/verify-otp-email" element={<VerifyOTPEmail />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/change-email-page" element={<ResetEmail/>} />
                <Route path="/change-email" element={<ChangeEmail />} />
            </Routes>
        </Router>
    );
};

export default App;